import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { api, useAuth } from "@/App";

const APPS = {
  luxe: { name: "LuxeMeet", favicon: "/favicon.png" },
  dluxe: { name: "DLuxe", favicon: "/favicon-dluxe.png" },
};

const AppModeContext = createContext(null);

export const useAppMode = () => useContext(AppModeContext);

export function AppModeProvider({ children }) {
  const { user } = useAuth();
  const [mode, setMode] = useState(() =>
    localStorage.getItem("app_mode") === "dluxe" ? "dluxe" : "luxe"
  );

  // Keep the API header in sync during render so children always send the right mode
  api.defaults.headers.common["X-App-Mode"] = mode;

  useEffect(() => {
    localStorage.setItem("app_mode", mode);
    api.defaults.headers.common["X-App-Mode"] = mode;
    document.title = `${APPS[mode].name} | Premium Dating`;
    const link = document.querySelector("link[rel='icon']");
    if (link) link.href = APPS[mode].favicon;
    document.documentElement.classList.toggle("dluxe", mode === "dluxe");
  }, [mode]);

  const toggleMode = useCallback(() => setMode((m) => (m === "luxe" ? "dluxe" : "luxe")), []);

  const value = useMemo(() => {
    const isDluxe = mode === "dluxe";
    const payerGender = isDluxe ? "female" : "male";
    return {
      mode,
      isDluxe,
      appName: APPS[mode].name,
      otherAppName: APPS[isDluxe ? "luxe" : "dluxe"].name,
      toggleMode,
      payerGender,
      isPayer: user?.gender === payerGender,
      isEarner: !!user?.gender && user.gender !== payerGender,
    };
  }, [mode, toggleMode, user?.gender]);

  return <AppModeContext.Provider value={value}>{children}</AppModeContext.Provider>;
}
